var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: _vm.supplierSelectorRef,
      staticClass: "select_items_filter_wrapper",
      attrs: { id: _vm.supplierSelectorRef },
    },
    [
      _vm.showDefaultLabel
        ? _c(
            "label",
            {
              staticClass: "d-block",
              attrs: { for: "slectfilter_component_elem" },
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t")]
          )
        : _vm._e(),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              class: `${_vm.useNewDesign ? "d-flex" : ""}`,
              attrs: {
                md: !_vm.hideAction && !_vm.useNewDesign ? 8 : 12,
                lg: !_vm.hideAction && !_vm.useNewDesign ? 8 : 12,
              },
            },
            [
              _c("v-select", {
                key: _vm.supplierKey,
                class: {
                  "grow-flex-auto": _vm.useNewDesign && _vm.version === "1.0",
                  "border-radius-supplier": !_vm.hideAction,
                },
                attrs: {
                  id: `${_vm.useNewDesign ? "supplier-selector" : ""}`,
                  placeholder: _vm.placeholder,
                  reduce: (option) => option.code,
                  options: _vm.mapItems,
                  disabled: _vm.disabled,
                },
                on: { input: _vm.handleChange },
                scopedSlots: _vm._u(
                  [
                    _vm.version === "2.0"
                      ? {
                          key: "selected-option",
                          fn: function ({ label }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center parent-selected-option",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "selected-option-label",
                                      staticStyle: {
                                        color: "rgba(6, 38, 62, 0.84)",
                                      },
                                    },
                                    [_vm._v(_vm._s(label))]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover.top",
                                          modifiers: { hover: true, top: true },
                                        },
                                      ],
                                      staticClass: "cursor-pointer px-1",
                                      attrs: {
                                        title: _vm.FormMSG(8, "Update"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          return _vm.openEditSupplierModal()
                                        },
                                      },
                                    },
                                    [
                                      _c(_vm.getLucideIcon("Edit"), {
                                        tag: "component",
                                        attrs: {
                                          color: "#225CBD",
                                          size: 18,
                                          "stroke-width": 2.25,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover.top",
                                          modifiers: { hover: true, top: true },
                                        },
                                      ],
                                      staticClass: "cursor-pointer px-1",
                                      attrs: { title: _vm.FormMSG(9, "Map") },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          _vm.isMappedSupplierModalOpen = true
                                        },
                                      },
                                    },
                                    [
                                      _c(_vm.getLucideIcon("Map"), {
                                        tag: "component",
                                        attrs: {
                                          color: "rgba(6, 38, 62, 0.5)",
                                          size: 18,
                                          "stroke-width": 2.25,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        }
                      : null,
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selectedSupplier,
                  callback: function ($$v) {
                    _vm.selectedSupplier = $$v
                  },
                  expression: "selectedSupplier",
                },
              }),
              !_vm.hideAction && _vm.useNewDesign
                ? _c(
                    "div",
                    { staticClass: "d-flex flex-row icon-group-border-append" },
                    [
                      (_vm.version === "1.0" && !_vm.isModifiable) ||
                      _vm.version === "2.0"
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.top",
                                  modifiers: { hover: true, top: true },
                                },
                              ],
                              staticClass:
                                "cursor-pointer d-inline-flex justify-content-center align-items-center",
                              style: `width: ${_vm.defaultIconWidth}`,
                              attrs: { title: _vm.FormMSG(7, "Add") },
                              on: {
                                click: function ($event) {
                                  return _vm.openAddSupplierModal()
                                },
                              },
                            },
                            [
                              _c(_vm.getLucideIcon("PlusCircle"), {
                                tag: "component",
                                attrs: {
                                  color: "#00A09C",
                                  size: 18,
                                  "stroke-width": 2.25,
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.top",
                                  modifiers: { hover: true, top: true },
                                },
                              ],
                              staticClass:
                                "cursor-pointer d-inline-flex justify-content-center align-items-center",
                              style: `width: ${_vm.defaultIconWidth}`,
                              attrs: { title: _vm.FormMSG(8, "Update") },
                              on: {
                                click: function ($event) {
                                  return _vm.openEditSupplierModal()
                                },
                              },
                            },
                            [
                              _c(_vm.getLucideIcon("Edit"), {
                                tag: "component",
                                attrs: {
                                  color: "#225CBD",
                                  size: 18,
                                  "stroke-width": 2.25,
                                },
                              }),
                            ],
                            1
                          ),
                      _vm.version === "1.0" && _vm.isModifiable && _vm.showMap
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.top",
                                  modifiers: { hover: true, top: true },
                                },
                              ],
                              staticClass:
                                "cursor-pointer d-inline-flex justify-content-center align-items-center",
                              style: `width: ${_vm.defaultIconWidth}`,
                              attrs: { title: _vm.FormMSG(9, "Map") },
                              on: {
                                click: function ($event) {
                                  _vm.isMappedSupplierModalOpen = true
                                },
                              },
                            },
                            [
                              _c(_vm.getLucideIcon("Map"), {
                                tag: "component",
                                attrs: {
                                  color: "rgba(6, 38, 62, 0.5)",
                                  size: 18,
                                  "stroke-width": 2.25,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          !_vm.hideAction && !_vm.useNewDesign
            ? _c(
                "b-col",
                {
                  class: `${_vm.$screen.width <= 992 ? "mt-2" : ""}`,
                  attrs: { md: "4", lg: "4" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "actions_holder" },
                    [
                      _vm.isModifiable && _vm.showMap
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.top",
                                  modifiers: { hover: true, top: true },
                                },
                              ],
                              staticClass: "map-btn",
                              attrs: {
                                disabled: _vm.mapDisabled,
                                title: _vm.FormMSG(9, "Map"),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.isMappedSupplierModalOpen = true
                                },
                              },
                            },
                            [
                              _c(_vm.getLucideIcon("Map"), {
                                tag: "component",
                                staticStyle: {
                                  "margin-left": "-4px",
                                  "margin-top": "-3px",
                                },
                                attrs: {
                                  color: "#FFF",
                                  size: 18,
                                  "stroke-width": 2,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "supplier_actions_btns has_two_btn",
                          class: `${!_vm.isModifiable ? "w-100" : ""}`,
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { disabled: _vm.disabled },
                              on: {
                                click: function ($event) {
                                  !_vm.isModifiable
                                    ? _vm.openAddSupplierModal()
                                    : _vm.openEditSupplierModal()
                                },
                              },
                            },
                            [
                              _vm.isModifiable
                                ? _c("edit", {
                                    staticStyle: { "margin-top": "-3px" },
                                    attrs: { color: "#FFFFFF", size: 18 },
                                  })
                                : _c("plus-circle", {
                                    staticStyle: { "margin-top": "-3px" },
                                    attrs: { color: "#FFFFFF", size: 18 },
                                  }),
                            ],
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                block: "",
                                variant: "outline-primary",
                                disabled: _vm.disabled,
                              },
                              on: {
                                click: function ($event) {
                                  !_vm.isModifiable
                                    ? _vm.openAddSupplierModal()
                                    : _vm.openEditSupplierModal()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    !_vm.isModifiable
                                      ? _vm.addlabel
                                      : _vm.updateLabel
                                  ) +
                                  "\n\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("SupplierModal", {
        key: _vm.addressModalKey,
        attrs: {
          "supplier-candidate": _vm.supplierCandidate,
          editable: _vm.isModifiable,
          title: _vm.modalTitle,
          "current-search": _vm.currSearch,
          "focus-supplier": _vm.editSupplierPayload,
          "from-project-config": _vm.fromProjectConfig,
        },
        on: {
          "supplier-name-change": _vm.handleSupplierNameChange,
          submit: _vm.handleAddressSubmit,
          "delete-supplier": _vm.handleDeleteSupplier,
        },
        model: {
          value: _vm.isAddressModalOpen,
          callback: function ($$v) {
            _vm.isAddressModalOpen = $$v
          },
          expression: "isAddressModalOpen",
        },
      }),
      !_vm.mapDisabled
        ? _c("MappedSuppliersModal", {
            key: _vm.supplierKey,
            attrs: {
              selection: _vm.selectedSupplier,
              suppliers: _vm.suppliers,
              placeholder: _vm.placeholder,
            },
            on: { selected: _vm.setSelectedSupplier },
            model: {
              value: _vm.isMappedSupplierModalOpen,
              callback: function ($$v) {
                _vm.isMappedSupplierModalOpen = $$v
              },
              expression: "isMappedSupplierModalOpen",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }